"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDocumentType = void 0;
var ProjectDocumentType;
(function (ProjectDocumentType) {
    ProjectDocumentType["CONTRACT"] = "contract";
    ProjectDocumentType["IMAGE"] = "image";
    ProjectDocumentType["MISC"] = "misc";
})(ProjectDocumentType || (exports.ProjectDocumentType = ProjectDocumentType = {}));
